module.exports = __webpack_public_path__ + "static/media/service-area-icon.27b64ea4.svg";